import socketIoAPI from '@/modules/socketAPI.js'
import vueAPI from '@/modules/vueAPI.js'

export default {
    state: {
        hasObserver: false,
        webpSupport: {
            support: false,
            loseless: false,
        },
        screen: {
            width: window.innerWidth,
            height: window.innerHeight,
        }
    },
    getters: {
        hasObserver: state => state.hasObserver,
        webpSupport: state => state.webpSupport.support,
        webpLoseless: state => state.webpSupport.loseless,
        screenWidth: state => state.screen.width,
        screenHeight: state => state.screen.height,
    },
    mutations: {
    },
    actions: {
    },
}

vueAPI.onMounted((thisVue) => {
    window.addEventListener('resize', () => {
        thisVue.$store.state.globalData.screen.width = window.innerWidth
        thisVue.$store.state.globalData.screen.height = window.innerHeight
    })
})